import { render, staticRenderFns } from "./formation.vue?vue&type=template&id=4e9642aa&"
import script from "./formation.vue?vue&type=script&lang=js&"
export * from "./formation.vue?vue&type=script&lang=js&"
import style0 from "./formation.vue?vue&type=style&index=0&id=4e9642aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports